import { createSlice } from "@reduxjs/toolkit";

const cachedRequestsSlice = createSlice({
  name: "cachedRequests",
  initialState: {
    vehiclesRequest: [],
    servicesRequest: [],
    chatLink: "",
    bookingSettings: {},
    toggle: false,
  },
  reducers: {
    setVehiclesRequest: (state, { payload }) => {
      state.vehiclesRequest = payload;
    },
    setServicesRequest: (state, { payload }) => {
      state.servicesRequest = payload;
    },
    setSupportLink: (state, { payload }) => {
      state.chatLink = payload;
    },
    setBookingSettings: (state, { payload }) => {
      state.bookingSettings = payload;
    },
    refreshRequests: (state, { payload }) => {
      state.toggle = payload;
    },
  },
});

export const {
  setSupportLink,
  setVehiclesRequest,
  setServicesRequest,
  setBookingSettings,
  refreshRequests,
} = cachedRequestsSlice.actions;

export default cachedRequestsSlice.reducer;
